import React from "react";

import { MetricQuery } from "~/models/metric-query";

import type { MonitorCheckStatusMetric } from "../../../../../../common/openapi";
import { ThumbnailTimeSeriesChart } from "../../../../../../components/react/metrics/ThumbnailTimeSeriesChart";

import { useMonitorStatusContext } from "./_monitor-status-context";

export interface MonitorStatusMetricsProps {
	metrics: ReadonlyArray<MonitorCheckStatusMetric>;
}

export const MonitorStatusMetrics: React.FC<MonitorStatusMetricsProps> = ({ metrics }) => {
	const { timeRange } = useMonitorStatusContext();

	return (
		<div className="space-y-4" data-testid="monitor-status-metrics">
			{metrics.map(({ name, description, unit, queries }) => (
				<ThumbnailTimeSeriesChart
					batch={name}
					description={description}
					key={name}
					metricQueries={queries.map(MetricQuery)}
					timeRange={timeRange}
					title={name}
					unit={unit}
				/>
			))}
		</div>
	);
};
